import React, { useContext, useEffect, useState } from 'react';
import { Grid, Typography, Card, CardContent, Avatar, Button, Box, Chip, useMediaQuery } from '@mui/material';
import Feed from '../../Components/Feed';
import { getBasicProfileSetting, getFeeds, getJobs, getRecentAlumniDetail } from '../../Utils/apiService';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import routes from '../../Utils/routes';
import Images from '../../Assets/assetHelper';
import { useNavigate } from 'react-router-dom';
import Promotionalbanner from '../../Components/Promotionalbanner';
import KenButton from '../../GlobalComponents/KenButton';
interface MediaItem {
    url: string;
    type: string;
}
interface FeedItem {
    userImage: string;
    title: string;
    date: string;
    mediaLogo: string;
    content: string;
    hashtags: string;
    media: MediaItem[];
}
function linkify(text: string) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => {
        return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#1976d2;text-decoration:underline;">${url}</a>`;
    });
}

const MyFeed = () => {
    const { state: { user } } = useContext(AuthContext);
    const userData = user as any;
    const [feedData, setFeedData] = useState<FeedItem[]>([]);
    const navigate = useNavigate();
    const [jobs, setJobs] = useState<any[]>([]);
    const isMobile = useMediaQuery('(max-width:900px)');
    useEffect(() => {
        getFeeds().then((res) => {
            const apiData = res?.data?.x || [];
            console.log(apiData, "apiDataapiDataapiDataapiData");

            const formattedData = apiData.map((item: any) => {
                const date = new Date(item.created_at.split(" ")[0]);
                const formattedDate = date.toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                }).replace(/ /g, ' ');
                const hashtags = (item.text.match(/#[\w]+/g) || []).join(' ');
                return {
                    userImage: item?.user?.pfp_url ? item?.user?.pfp_url : "https://images.crunchbase.com/image/upload/c_pad,h_256,w_256,f_auto,q_auto:eco,dpr_1/kbstmn3zvcx9xiutzxso",
                    title: item?.user?.username ? item?.user?.username : "-",
                    date: `${formattedDate}`,
                    mediaLogo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRj-X06O3ppyMhQotOP_Km27fpwe0FgZGqXiA&s",
                    content: item.text,
                    hashtags: hashtags,
                    media: item.media ? item.media.map((m: any) => ({
                        url: m.url,
                        type: m.type, // photo, video, animated_gif
                    })) : [],
                };
            });
            setFeedData(formattedData);
        });
        Promise.all([
            getBasicProfileSetting(userData.applicantId),
            getJobs(userData.applicantId)
        ]).then(([profileRes, jobsRes]) => {
            // Get the current or permanent city in lowercase
            const currentAddress =
                profileRes?.currentAddress?.[0]?.City__c ||
                profileRes?.permanentAddress?.[0]?.City__c ||
                "";
            const locationToMatch = currentAddress.toLowerCase();
            console.log(locationToMatch, "Normalized current address");

            // Merge all jobs and remove duplicates by Id
            const allJobs = jobsRes?.data?.allJobs || [];
            const featuredJobs = jobsRes?.data?.featuredJobs || [];
            const combinedJobs = [...allJobs, ...featuredJobs];

            const uniqueJobs = Array.from(
                new Map(combinedJobs.map((job) => [job.Id, job])).values()
            );

            // Filter jobs where Location__c matches the address (case-insensitive)
            const filteredJobs = uniqueJobs.filter((job) =>
                job.Location__c?.toLowerCase() === locationToMatch
            );
            const transformedJobs = filteredJobs.map((job: any, index: number) => ({
                id: index + 1,
                title: job.Job_Title__c || "N/A",
                company: job.Organization__r?.Name || "N/A",
                location: job.Location__c ? `${job.Location__c}, India` : "India",
                logo: "https://t4.ftcdn.net/jpg/05/05/61/73/360_F_505617309_NN1CW7diNmGXJfMicpY9eXHKV4sqzO5H.jpg",
                tags: job.Work_Place_Type__c
                    ? job.Work_Place_Type__c.split(";").map((t: string) => t.trim()).filter(Boolean)
                    : ["Onsite"],
            }));
            setJobs(transformedJobs);
        });

    }, []);
    const [NetworkCha, setNetworkChat] = useState<any[]>([]);

    useEffect(() => {
        getRecentAlumniDetail().then((res) => {
            const formatted =
                res?.data?.data?.map((chat: any) => ({
                    name: chat.contactName,
                    avatar: chat.profilePicUrl || Images.Images.NoDataTheme,
                })) || [];
            setNetworkChat(formatted);
        });
    }, []);
    return (
        <div>
            <Grid container spacing={2}>

                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={8}
                    xl={8}
                    lg={8}
                    sx={{
                        height: isMobile ? "100%" : "calc(100vh - 125px)",
                        display: "flex",
                        flexDirection: "column",
                        overflow: "hidden",
                    }}
                >
                    <Promotionalbanner />
                    <Box sx={{ flex: 1, minHeight: 0 }}>
                        <Feed containerHeight={isMobile ? undefined : "100%"} />
                    </Box>
                </Grid>
                {isMobile ? null : (
                    <Grid item md={4} xl={4} lg={4} sx={{ height: "calc(100vh - 125px)", borderRadius: "10px", overflowY: 'auto' }} className="scrollbar-cusgray">
                        {/* Jobs in your location */}
                        <Box  sx={{ backgroundColor: "white", borderRadius: "10px", px: 2, py: 2 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontWeight={500}>Jobs In Your Location</Typography>
                                <Button size="small" variant="contained" color='secondary' onClick={() => navigate(routes.jobs)}>View all</Button>
                            </Box>
                            {jobs.length > 0 ? (
                                jobs.slice(0, 2).map(job => (
                                    <Card key={job.id} sx={{ mt: 2, p: 2, backgroundColor: "#F6F8FB", boxShadow: "none" }}>
                                        <Box display="flex" alignItems="center" mb={1}>
                                            <Avatar src={job.logo} sx={{ width: 40, height: 40, mr: 2 }} />
                                            <Box>
                                                <Typography fontWeight={600}>{job.title}</Typography>
                                                <Typography fontSize="14px" color="text.secondary">{job.company} | {job.location}</Typography>
                                            </Box>
                                        </Box>
                                        <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
                                            {job.tags.map((tag: string, index: number) => (
                                                <Chip key={`${tag}-${index}`} label={tag} size="small" variant="outlined" />
                                            ))}
                                        </Box>
                                    </Card>
                                ))
                            ) : (
                                <Box mt={3} textAlign="center">
                                    <Typography color="text.secondary" fontSize={12}>
                                        There are no available jobs in your location.
                                    </Typography>
                                    <br />
                                    <Button
                                        variant="contained"
                                        color='primary'
                                        size='large'
                                        onClick={() => navigate(routes.jobs)}
                                    >
                                        <Typography fontSize={12} fontWeight={500}>Browse all jobs</Typography>
                                    </Button>
                                </Box>
                            )}
                        </Box>

                        {/* Recent members */}
                        <Box mt={2} sx={{ backgroundColor: "white", borderRadius: "10px", p: 2 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontWeight={500}>Recent Members ({NetworkCha?.length})</Typography>
                                <Button size="small" variant="contained" color='secondary' onClick={() => navigate(routes.network)}>View all</Button>
                            </Box>
                            <Grid container spacing={1} mt={1}>
                                {NetworkCha.slice(0, 8).map((items: any, index: number) => {
                                    console.log(items, "itemsitemsitemsitems");

                                    return (
                                        <Grid item xs={3} key={items.id} sx={{ backgroundColor: "#F6F8FB", borderRadius: "10px", p: 1, m: 1 }}>
                                            <center>
                                                <Avatar src={items.avatar} alt={items.name} sx={{ width: 56, height: 56 }} />
                                            </center>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                        </Box>
                        <Box mt={2} sx={{ backgroundColor: "white", borderRadius: "10px", p: 2 , minHeight : '20vh'}}>
                            {(() => {
                                const postsWithMedia = feedData
                                    .filter(item => item.media && item.media.length > 0)
                                    .sort((a, b) => {
                                        const parseDate = (dateStr: string) => {
                                            const [day, month, year] = dateStr.split(' ');
                                            return new Date(`${month} ${day}, ${year}`);
                                        };
                                        return parseDate(b.date).getTime() - parseDate(a.date).getTime();
                                    });
                                const latestPost = postsWithMedia[0];
                                if (!latestPost) return null;
                                return (
                                    <Box
                                        key={0}
                                        sx={{
                                            border: "1px solid #E6E6E8",
                                            borderRadius: "10px",
                                            mt: 2,
                                            backgroundColor: "white",
                                            height: '100%',
                                            p: 2,
                                        }}
                                    >
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={2}>
                                                <img
                                                    src={latestPost.userImage}
                                                    alt="User"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                        ...(window.innerWidth >= 1240 ? { width: "30px", height: "30px" } : {})
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={8} style={{ textAlign: "left" }}>
                                                <Typography sx={{ fontWeight: 500 }}>{latestPost.title}</Typography>
                                                <Typography sx={{ fontSize: 12, color: "gray" }}>{latestPost.date}</Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <img
                                                    src={latestPost.mediaLogo}
                                                    alt="Media"
                                                    style={{
                                                        width: "40px",
                                                        height: "40px",
                                                        borderRadius: "50%",
                                                        ...(window.innerWidth >= 1240 ? { width: "30px", height: "30px" } : {})
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Typography
                                            mt={3}
                                            fontSize={14}
                                            textAlign={"left"}
                                            component="div"
                                            dangerouslySetInnerHTML={{ __html: linkify(latestPost.content) }}
                                        />
                                        {latestPost.hashtags && (
                                            <Typography mt={2} fontSize={14}
                                                textAlign={"left"} color="primary.main">
                                                {latestPost.hashtags}
                                            </Typography>
                                        )}
                                        {/* Media section */}
                                        {latestPost.media.length > 0 && (
                                            <Box mt={2} sx={{ display: 'flex', overflowX: 'auto', gap: 2 }}>
                                                {latestPost.media.map((mediaItem, idx) => (
                                                    <Box key={idx} sx={{ minWidth: "100%", borderRadius: "10px", overflow: "hidden" }}>
                                                        {mediaItem.type === "photo" && (
                                                            <img
                                                                src={mediaItem.url}
                                                                alt={`media-${idx}`}
                                                                style={{
                                                                    width: "100%",
                                                                    height: "auto",
                                                                    objectFit: "cover",
                                                                    borderRadius: "10px",
                                                                }}
                                                            />
                                                        )}
                                                        {mediaItem.type === "video" && (
                                                            <video
                                                                src={mediaItem.url}
                                                                autoPlay
                                                                controls
                                                                style={{
                                                                    width: "100%",
                                                                    height: "auto",
                                                                    objectFit: "cover",
                                                                    borderRadius: "10px",
                                                                }}
                                                            />
                                                        )}
                                                        {mediaItem.type === "animated_gif" && (
                                                            <video
                                                                src={mediaItem.url}
                                                                autoPlay
                                                                loop
                                                                muted
                                                                playsInline
                                                                style={{
                                                                    width: "100%",
                                                                    height: "auto",
                                                                    objectFit: "cover",
                                                                    borderRadius: "10px",
                                                                }}
                                                            />
                                                        )}
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}
                                    </Box>
                                );
                            })()}
                        </Box>
                    </Grid>)}
            </Grid>
        </div>
    );
};

export default MyFeed;
